import React from 'react';
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import routes from './routers';
import AnimatedRouter from 'react-animated-router';
import { AliveScope } from 'react-activation'
import 'react-animated-router/animate.css';

function App() {
  return (
    <Router>
      <div className="app">
        <AliveScope>
          <AnimatedRouter className="app-router" timeout={240}>
              {renderRoutes(routes)}
          </AnimatedRouter>
        </AliveScope>
      </div>
    </Router>
  );
}

export default App;
